import {withRouter} from 'react-router-dom'
import ReactPlayer from 'react-player'
import {AiOutlineLike, AiOutlineDislike} from 'react-icons/ai'
import {MdPlaylistAdd} from 'react-icons/md'

import NxtWatchContext from '../../NxtWatchContext/NxtWatchContext'

import {
  VideoDescriptionContainer,
  LikeContent,
  LikeBtn,
  DynamicContainer,
  StaticContentContainer,
  StaticAndDynamicInfoContainer,
  VideoTitle,
  VideoDescription,
  SubscriberCount,
  ChannelName,
  AboutChannelAndDescriptionContainer,
  ChannelImg,
  ChannelAndVideoDescriptionContainer,
  HorizontalLine,
  AddPlaylistBtn,
  SaveContent,
  DisLikeBtn,
} from './styledComponents'
import {
  Duration,
  ViewsCnt,
  ViewsAndDurationContainer,
} from '../HomePageVideoItem/styledComponents'

const WatchVideoContainer = props => (
  <NxtWatchContext.Consumer>
    {value => {
      const {
        videoDetails,
        isLiked,
        isDisLiked,
        onClickLike,
        onClickDisLike,
      } = props
      const {
        title,
        videoUrl,
        channel,
        viewCount,
        publishedDuration,
        description,
      } = videoDetails

      const {onClickSave, savedVideosList, darkMode} = value

      const onClickSaveBtn = () => onClickSave(videoDetails)
      const {match} = props
      const {params} = match
      const {id} = params
      const isSaved = savedVideosList.some(eachItem => eachItem.id === id)
      const savedMsg = isSaved ? 'Saved' : 'Save'
      return (
        <VideoDescriptionContainer>
          <ReactPlayer url={videoUrl} width="98%" height="65%" />
          <VideoTitle darkMode={darkMode}>{title}</VideoTitle>
          <StaticAndDynamicInfoContainer>
            <StaticContentContainer>
              <ViewsAndDurationContainer>
                <ViewsCnt>{viewCount} views</ViewsCnt>
                <Duration>{publishedDuration}</Duration>
              </ViewsAndDurationContainer>
            </StaticContentContainer>
            <DynamicContainer>
              <LikeBtn type="button" liked={isLiked} onClick={onClickLike}>
                <AiOutlineLike />
                <LikeContent>Like</LikeContent>
              </LikeBtn>
              <DisLikeBtn
                type="button"
                disliked={isDisLiked}
                onClick={onClickDisLike}
              >
                <AiOutlineDislike />
                <LikeContent>Dislike</LikeContent>
              </DisLikeBtn>
              <AddPlaylistBtn
                type="button"
                isSaved={isSaved}
                onClick={onClickSaveBtn}
              >
                <MdPlaylistAdd />
                <SaveContent>{savedMsg}</SaveContent>
              </AddPlaylistBtn>
            </DynamicContainer>
          </StaticAndDynamicInfoContainer>
          <HorizontalLine />
          <ChannelAndVideoDescriptionContainer>
            <ChannelImg src={channel.profileImgUrl} alt="channel logo" />
            <AboutChannelAndDescriptionContainer>
              <ChannelName darkMode={darkMode}>{channel.name}</ChannelName>
              <SubscriberCount>
                {channel.subscriberCount} subscribers
              </SubscriberCount>
              <VideoDescription>{description}</VideoDescription>
            </AboutChannelAndDescriptionContainer>
          </ChannelAndVideoDescriptionContainer>
        </VideoDescriptionContainer>
      )
    }}
  </NxtWatchContext.Consumer>
)

export default withRouter(WatchVideoContainer)
